import { render, staticRenderFns } from "./ViewWeldingInspector.vue?vue&type=template&id=437d9b54"
import script from "./ViewWeldingInspector.vue?vue&type=script&lang=js"
export * from "./ViewWeldingInspector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports